import { useQuery } from '@tanstack/react-query'
import { fetchPaygUsage } from '../subscriptions'

export const paygUsageQueryKey = (slug: string) => [slug, 'stripe', 'payg-usage'] as const

export const paygUsageQueryOptions = (slug: string) => ({
  queryKey: paygUsageQueryKey(slug),
  queryFn: () => fetchPaygUsage({ slug })
})

export const usePaygUsage = (slug: string, enabled = true) =>
  useQuery({
    ...paygUsageQueryOptions(slug),
    enabled
  })
